import { PaymentMethodType, PreferredPaymentMethod, SupportedLocale } from '@afterpay/types'
import { IdentityCheckStatus } from '@afterpaytouch/portal-api'

export const isIdentityValid = (identity: IdentityCheckStatus | undefined): boolean =>
  identity === IdentityCheckStatus.VERIFIED || identity === IdentityCheckStatus.NOT_REQUIRED

export const hasPreferredPaymentMethod = (preferredPaymentMethod: PreferredPaymentMethod | PaymentMethodType | null | undefined): boolean =>
  preferredPaymentMethod !== null

export const isCashCohort = (uuid: string | undefined | null): boolean => uuid?.startsWith('C_') ?? false

export const isHardIdVerificationRequiredLocale = (locale: SupportedLocale | undefined): boolean => {
  return locale === 'en-NZ' || locale === 'en-GB' || locale === 'en-AU'
}
